import { createMachine, actions, interpret } from "xstate";

const baseModel = {
    id: "button-base",
    context: {
        permanent: true,
    },
    initial: "inactive",
    states: {

        inactive: {
            on: {
                activate: {target: "selected"}
            }
        },

        selected: {
            entry: "checkPermanent",
            on: {
                toolTaskDone: [
                    {cond: "isPermanent", target: "selected"},
                    {cond: "isNotPermanent", target: "finished"}],
                exit : [
                    {cond: "isPermanent", target: "inactive"},
                    {cond: "isNotPermanent", target: "finished"}]
            },
        },

        finished: {
            type: "final",
        },
    },

};

const config = {
    guards: {
        isPermanent: (ctx, evt) => ctx.permanent,
        isNotPermanent: (ctx, evt) => !ctx.permanent,
    },

    actions: {
        checkPermanent: (ctx, evt) => {
            if (evt.doubleClicked) {
                ctx.permanent = true;
            }
        },
    },
};

// export default interpret(new Machine(baseModel));
export default createMachine(baseModel, config);